module.exports = __webpack_public_path__ + "media/features/templates/components/assets/slot-placeholder-4734ebe0fb71da551296f3259725d2e7.png";